import {IPlayHubStore} from "apps/BWW_PLAY_HUB/modules/utils/types";

export const getAdSlots = ({adSlots}: IPlayHubStore) => adSlots;